import styled from "styled-components";

export const SDuplicateProjectProgressModalButton = styled.div`
  margin: 0 auto 0 auto;
  width: 784px;
`;
